import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoPageHeaderComponent} from '../../shared/components/info-page-header/info-page-header.component';
import {ReactiveFormsModule} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {CheckInEndComponent} from '../check-in-end/check-in-end.component';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {MetricsService} from '../../core/services/metrics.service';

@Component({
  selector: 'app-check-in-minor-end',
  templateUrl: './check-in-minor-end.component.html',
  styleUrls: ['./check-in-minor-end.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InfoPageHeaderComponent, RouterLink],
})
export class CheckInMinorEndComponent extends CheckInEndComponent implements OnInit {

  constructor(
    router: Router,
    hoomvipStorage: HoomvipStorage,
    metricsService: MetricsService,
  ) {
    super(router, hoomvipStorage, metricsService);
  }

  protected override trackCheckInEnded(): void {
    this.metricsService.checkInMinorEnded();
  }
}
